import React, {Component} from 'react'
import {Helmet} from 'react-helmet'
import {APP_NAME} from '~/utils/constants'
// import {BridgeFrame} from '../component/BridgeFrame'
import {InitDeviceInfo, Debug} from './comps'
import s from './index.module.less'
import { generateUniqueUUID } from '~/utils/math'
class App extends Component {
  state = {
    errMsg: '',
    onFinishLoad: false
  }

  handleWindowLoad = () => {
    this.setState({onFinishLoad: true})
  }

  componentDidMount() {
    // app 级别的公用逻辑可以放到这里
    // 比如白天、夜间模式功能

    // 存储不可用时 localStorage 会抛 SecurityError，不能让它卸载整棵组件树
    try {
      let uid = window.localStorage.getItem('uuid')
      if (!uid) {
        const ua = window.navigator.userAgent
        const ip = window.navigator.ip
        uid = generateUniqueUUID(ip, ua)
        window.localStorage.setItem('uuid', uid)
      }
    } catch (error) {
      // ignore
    }
    if (this.props.skipWindowLoad) {
      this.handleWindowLoad()
      return
    }
    if (typeof window !== 'undefined') {
      // load 事件可能在 App 挂载前已触发（async chunk / 缓存命中），
      // 只监听 load 会偶发永远不渲染 children，表现为白屏
      if (document.readyState === 'complete') {
        this.handleWindowLoad()
      } else {
        window.addEventListener('load', this.handleWindowLoad)
      }
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('load', this.handleWindowLoad)
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({errMsg: error.message || '出了一些错误'})
  }

  render() {
    const {errMsg, onFinishLoad} = this.state
    const initialTitle =
      typeof window !== 'undefined' &&
      window.location.pathname === '/help/communityConvention'
        ? '社群公约'
        : APP_NAME

    return (
      <>
        <InitDeviceInfo />
        <Debug />
        {/* <BridgeFrame /> */}
        {/* <Jweixin /> */}
        <Helmet>
          <meta httpEquiv="Cache-Control" content="no-catch" />
          <meta name="referrer" content="strict-origin-when-cross-origin" />
          <title>{initialTitle}</title>
          <meta name="description" content={APP_NAME} />
        </Helmet>
        {errMsg && (
          <div className={s.errWrap}>
            <p>some err</p>
            <p>{errMsg}</p>
            <p
              onClick={() => {
                window.location.reload()
              }}
            >
              点击刷新
            </p>
          </div>
        )}
        {!errMsg && onFinishLoad && this.props.children}
      </>
    )
  }
}

export default App
